<p-toast></p-toast>

<p-sidebar [(visible)]="isVisibleDisplayDriverPayoutInvoice"
           [position]="'right'"
           [baseZIndex]="11000"
           (onHide)="cancel()"
           [style]="{width:'700px'}">

    <ng-template pTemplate="header">
        <div class="order-details-payment-head">Invoice ID: </div>
        <div class="order-details-payment-head ml-2">{{riderInvoice?.InvoiceId}}</div>
    </ng-template>

    <div class="bg-menu">
        <p-tabMenu [model]="menuItems" [scrollable]="true" [activeItem]="menuItems[0]"></p-tabMenu>
    </div>

    <div *ngIf="isLoading">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <div *ngIf="!isLoading">
        <div *ngIf="activeTab === menuTab.InvoiceDetails" class="mt-3 invoice-block">
            <div>
                <div class="flex">
                    <div class="transaction-detail-font mt-2 mb-2 ml-3 col-6 p-0">Invoice ID</div>
                    <div class="transaction-detail-font mt-2">{{riderInvoice?.InvoiceId}}</div>
                </div>
                <div class="flex">
                    <div class="transaction-detail-font mt-2 mb-2 ml-3 col-6 p-0">Invoice Date & Time</div>
                    <div class="transaction-detail-font mt-2">{{riderInvoice?.CreatedDateTime}}</div>
                </div>
                <div class="flex">
                    <div class="transaction-detail-font mt-2 mb-2 ml-3 col-6 p-0">Due Date</div>
                    <div class="transaction-detail-font mt-2">{{riderInvoice?.PaidDate}}</div>
                </div>
                <div class="flex">
                    <div class="transaction-detail-font mt-2 mb-2 ml-3 col-6 p-0">Status</div>
                    <div class="transaction-detail-font mt-2" [ngStyle]="{'color': getStatusColor(riderInvoice?.Status)}">{{riderInvoice?.Status}}</div>
                </div>
            </div>

            <hr class="mt-auto"/>

            <div class="flex ml-3 mr-3 justify-content-between">
                <div class="transaction-detail-font">Cashout Amount</div>
                <div class="transaction-detail-font">{{riderInvoice?.Amount}}</div>
            </div>

            <hr/>

            <div class="flex">
                <div class="invoice-w-50"></div>
                <div class="invoice-w-50 ml-5">
                    <div class="flex mr-3 justify-content-between">
                        <div class="transaction-detail-font">Transfer Fee</div>
                        <div class="transaction-detail-font">{{riderInvoice?.FeesPaidAmount}}</div>
                    </div>
                    <div class="flex mt-3 mb-2 mr-3 justify-content-between">
                        <div class="transaction-detail-font">Amount Due</div>
                        <div class="transaction-detail-font">{{riderInvoice?.PaidAmount}}</div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</p-sidebar>
